export const SIMULATION_NAME_MAX_LENGTH = 200;

const PRINTABLE_ASCII = /^[\x20-\x7E]*$/;

export const validateSimulationName = (raw) => {
  if (typeof raw !== "string") {
    return { trimmed: "", error: "Name must be a string." };
  }

  const trimmed = raw.trim();

  if (!PRINTABLE_ASCII.test(trimmed)) {
    return {
      trimmed,
      error:
        "Name can only contain printable ASCII characters (no emojis, accents, or line breaks).",
    };
  }

  if (trimmed.length > SIMULATION_NAME_MAX_LENGTH) {
    return {
      trimmed,
      error: `Name must be ${SIMULATION_NAME_MAX_LENGTH} characters or fewer.`,
    };
  }

  return { trimmed, error: null };
};
